import React, { useLayoutEffect, useState } from 'react';

export default function useRefDimensions(recalculateTriggerProps = []) {
  const ref = React.createRef();
  const [dimensions, setDimensions] = useState({});

  useLayoutEffect(() => {
    if (!ref.current) return;

    setDimensions(ref.current.getBoundingClientRect().toJSON());
  }, [ref.current, ...recalculateTriggerProps]);

  return [ref, dimensions];
}
